import React from 'react';
import { useTranslation } from 'react-i18next';

export const TopBar = ({ reportDate, source }) => {
    const { t } = useTranslation('reportPage');

    return (
        <header className="topbar">
            <div className="logo" aria-label="CheckVIN.ai">
                Check
                <br />
                <span style={{ paddingLeft: 40 }}>
                    <span style={{ color: 'var(--cv-pink)' }}>VIN</span>.ai
                </span>
            </div>
            <span className="muted">
                {t('page.reportFrom', { date: reportDate })}
                {source && ` · ${source}`}
            </span>
        </header>
    );
};
